'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Actions


// Selectors


// Style


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _AccountPopup = require('../../workspace/header/utils/account/AccountPopup');

var _AccountPopup2 = _interopRequireDefault(_AccountPopup);

var _NotificationPopup = require('../../workspace/header/utils/notifications/NotificationPopup');

var _NotificationPopup2 = _interopRequireDefault(_NotificationPopup);

var _BoardSharingPopup = require('../../workspace/header/utils/sharing/BoardSharingPopup');

var _BoardSharingPopup2 = _interopRequireDefault(_BoardSharingPopup);

var _BillingAlertPopup = require('../../workspace/header/utils/account/BillingAlertPopup');

var _BillingAlertPopup2 = _interopRequireDefault(_BillingAlertPopup);

var _Button = require('../buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _popupActions = require('./popupActions');

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

require('./PopupPanelMobileContainer.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUPPORTED_POPUPS = {
    user: _AccountPopup2.default,
    notification: _NotificationPopup2.default,
    sharing: _BoardSharingPopup2.default,
    'billing-alert': _BillingAlertPopup2.default
};

var activePopupNameSelector = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['app', 'popup', 'active']);
}, function (popupsMap) {
    if (!popupsMap.size) return;
    return popupsMap.keySeq().get(0);
});

var mapStateToProps = (0, _reselect.createSelector)(_gridSizeSelector.isMobileSize, activePopupNameSelector, function (isMobile, popupActive) {
    return {
        isMobile: isMobile,
        popupActive: popupActive
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchClosePopup: function dispatchClosePopup() {
            return dispatch((0, _popupActions.closePopup)());
        }
    };
};

var PopupPanelMobileContainer = function PopupPanelMobileContainer(props) {
    if (!props.isMobile || !props.popupActive) return null;

    var PopupElement = SUPPORTED_POPUPS[props.popupActive];
    if (!PopupElement) return null;

    return _react2.default.createElement(
        'div',
        { className: 'PopupPanelMobileContainer' },
        _react2.default.createElement(
            'div',
            { className: 'mobile-header' },
            _react2.default.createElement(
                _Button2.default,
                { onClickFn: props.dispatchClosePopup },
                _react2.default.createElement(_Icon2.default, { name: 'close-x' })
            )
        ),
        _react2.default.createElement(PopupElement, _extends({}, props, { isMobileView: true }))
    );
};

PopupPanelMobileContainer.propTypes = {
    isMobile: _propTypes2.default.bool,
    popupActive: _propTypes2.default.string,
    dispatchClosePopup: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PopupPanelMobileContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/PopupPanelMobileContainer.js
// module id = 1925
// module chunks = 0